import React from "react"
import styles from "./announcementModal.module.css"
import Button from "../Form/Button"
import FormattedAnnouncementText from "./FormattedAnnouncementText"
import { MdCampaign, MdClose, MdOpenInNew, MdOutlinePayments, MdOutlinePriorityHigh, MdOutlineSettings, MdTipsAndUpdates } from "react-icons/md"

const categoryData = {
    info: { label: "Informativo", icon: <MdCampaign /> },
    maintenance: { label: "Manutenção", icon: <MdOutlineSettings /> },
    billing: { label: "Cobrança", icon: <MdOutlinePayments /> },
    product: { label: "Produto", icon: <MdTipsAndUpdates /> },
    urgent: { label: "Importante", icon: <MdOutlinePriorityHigh /> },
}

const priorityLabels = {
    normal: "Comunicado",
    important: "Atenção",
    critical: "Ação necessária",
}

const formatDate = (date) => date ? new Date(date).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" }) : ""

const AnnouncementModal = ({ announcement, onClose, onAcknowledge, onViewAll, preview = false }) => {
    if (!announcement) return null

    const category = categoryData[announcement.category] || categoryData.info
    const requiresAcknowledgement = announcement.requires_acknowledgement && !preview
    const openAction = () => {
        const action = announcement.primary_action
        if (!action?.url) return
        if (action.type === "external" || /^https?:\/\//i.test(action.url)) {
            window.open(action.url, "_blank", "noopener,noreferrer")
            return
        }
        const accountId = window.location.pathname.split("/").filter(Boolean)?.[0]
        const destination = action.url.startsWith("/") && accountId && !action.url.startsWith(`/${accountId}/`) ? `/${accountId}${action.url}` : action.url
        window.location.href = destination
    }

    return (
        <div className={styles.backdrop} style={{ "--announcement-accent": announcement.accent_color || "#6245ae" }}>
            <section className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="announcement-title">
                <div className={styles.accent} />
                <div className={styles.header}>
                    <div className={styles.badges}>
                        <span className={styles.category}>{category.icon}{category.label}</span>
                        <span className={`${styles.priority} ${styles[announcement.priority]}`}>{priorityLabels[announcement.priority] || priorityLabels.normal}</span>
                    </div>
                    {!requiresAcknowledgement && <button type="button" className={styles.close} onClick={onClose} aria-label="Fechar"><MdClose /></button>}
                </div>
                <div className={styles.body}>
                    <span className={styles.date}>Publicado em {formatDate(announcement.published_at)}</span>
                    <h2 id="announcement-title">{announcement.title}</h2>
                    <p className={styles.summary}>{announcement.summary}</p>
                    {announcement.details && <FormattedAnnouncementText text={announcement.details} className={styles.details} />}
                    {announcement.expires_at && <span className={styles.validity}>Válido até {formatDate(announcement.expires_at)}</span>}
                </div>
                <div className={styles.actions}>
                    {onViewAll && <Button variant="neutral" onClick={onViewAll}>Ver todos os comunicados</Button>}
                    {announcement.primary_action?.label && announcement.primary_action?.url && <Button variant="neutral" onClick={openAction}>{announcement.primary_action.label}<MdOpenInNew /></Button>}
                    <Button variant={announcement.priority === "critical" ? "danger" : "secondary"} onClick={requiresAcknowledgement ? onAcknowledge : onClose}>
                        {requiresAcknowledgement ? "Li e estou ciente" : "Entendi"}
                    </Button>
                </div>
            </section>
        </div>
    )
}

export { categoryData, priorityLabels }
export default AnnouncementModal
